import { IFile } from "./models/IFile";
import { IUploadOptions } from "./models/IUploadOptions";


export const file: IFile = {
    id: "30-4354465",
    filename: "potretti.png",
    type: "png"
};

const sleep = async (ms = 500) => await new Promise((resolve) => setTimeout(resolve, ms));

export const defaultOptions: IUploadOptions = {
    uploadFile: async () => { await sleep(600); return file; },
    removeFile: async () => { await sleep(800); },

    getFileUrl: async (id) => id + "",
    getImageUrl: async (id) => id + "",
    getThumbnailUrl: (id, options) => id + "" + options?.height + options?.width,
    getFileInfo: async () => { await sleep(600); return { name: "potretti.png" }; },
};